// legacy/diagnostic-bridge.js — Bidirectional sync between diagnostic store and state.js
//
// Mirrors diagnostic data (compliance, scoring, revision) between
// diagnostic.store.js and legacy state.js so unmigrated Steps still work.
//
// @legacy PR-15 删除

import * as store from '../interaction/stores/diagnostic.store.js';

const DIAGNOSTIC_KEYS = [
  'complianceResult',
  'scoringReport',
  'revisionSuggestions',
  'revisionOverview',
  'revisionSuggestionsError',
];

let unsubStore = null;
const unsubState = [];
let initialized = false;

/**
 * Initialize the diagnostic ↔ state bridge.
 *
 * @param {Object} opts
 * @param {(key: string) => any} opts.getState
 * @param {(key: string, value: any) => void} opts.setState
 * @param {(event: string, cb: Function) => Function} opts.subscribe
 */
export function initDiagnosticBridge({ getState, setState, subscribe }) {
  if (initialized) return;
  initialized = true;

  // Seed store with current state values
  const seed = {};
  for (const key of DIAGNOSTIC_KEYS) {
    const val = getState(key);
    if (val !== null && val !== undefined) {
      seed[key] = val;
    }
  }
  if (Object.keys(seed).length > 0) {
    store.replaceDraft(seed);
  }

  // store → state: on store change, mirror to state.js
  unsubStore = store.subscribe(() => {
    const snap = store.getSnapshot();
    for (const key of DIAGNOSTIC_KEYS) {
      if (snap[key] !== getState(key)) {
        setState(key, snap[key]);
      }
    }
  });

  // state → store: on state event, mirror back to store
  for (const key of DIAGNOSTIC_KEYS) {
    const unsub = subscribe(`state:${key}Changed`, ({ curr }) => {
      if (curr !== store.getSnapshot()[key]) {
        store.patchDraft(key, curr);
      }
    });
    unsubState.push(unsub);
  }
}

/**
 * Tear down the bridge (for testing).
 */
export function destroyDiagnosticBridge() {
  if (unsubStore) { unsubStore(); unsubStore = null; }
  for (const fn of unsubState) fn();
  unsubState.length = 0;
  initialized = false;
}
